import request from '@/utils/request';
const base_path = '/material/report/jrtt';

/**
 * 重导头条素材报表数据
 * @param {Object} params 查询参数
 * @returns {Promise<Object>}
 */
export function pullJrttMaterialReportApi(params) {
  return request({
    url: `${base_path}/pull`,
    method: 'get',
    params,
  });
}
